import React from "react";

interface CheckIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({ width = 21, height = 20, color = "#47A37D" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10.5" cy="10" r="10" fill={color} />
      <path
        d="M5.78564 12.0659L7.88564 14.9641C7.95651 15.0629 8.0473 15.1432 8.15122 15.199C8.25514 15.2547 8.36947 15.2845 8.48564 15.2861C8.59995 15.2875 8.71311 15.2616 8.8169 15.2101C8.92069 15.1587 9.01249 15.0831 9.08564 14.9888L15.7856 6.28613"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckIcon;
